export class RefreshAuthenticationRequest
  implements IRefreshAuthenticationRequest
{
  token?: string | undefined;

  constructor(data?: IRefreshAuthenticationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
    }
  }

  static fromJS(data: any): RefreshAuthenticationRequest {
    data = typeof data === "object" ? data : {};
    let result = new RefreshAuthenticationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["token"] = this.token;
    return data;
  }
}

export interface IRefreshAuthenticationRequest {
  token?: string | undefined;
}